import type { ReactNode } from "react";

interface DetailPageShellProps {
  children: ReactNode;
}

export function DetailPageShell({ children }: DetailPageShellProps) {
  return (
    <div className="bg-background text-foreground">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 lg:px-20 py-8">{children}</div>
    </div>
  );
}
